<template>
  <div class="quad-viz-pure">
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>∠C = 90° | a² + b² = c²$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(150, 60)">
            <path d="M 0 0 L 0 150 L 200 150 Z" fill="rgba(0, 210, 255, 0.15)" stroke="#00d2ff" stroke-width="3" />
            
            <!-- Right angle -->
            <rect x="0" y="135" width="15" height="15" fill="none" stroke="#ffd700" stroke-width="2" />
            
            <!-- Sides Labels -->
            <text x="-20" y="75" fill="#888" text-anchor="middle">勾 a</text>
            <text x="100" y="170" fill="#888" text-anchor="middle">股 b</text>
            <text x="110" y="70" fill="#888" text-anchor="middle" transform="rotate(-36, 110, 70)">弦 c</text>
          </g>
        </svg>
      </div>

      <div class="bottom-controls">
        <div class="discovery-note" v-latex>
          <p><strong>直角三角形性质：</strong>有一个角为90°的三角形。两直角边分别为“勾”和“股”，斜边为“弦”。直角三角形满足勾股定理，且其外接圆圆心位于斜边的中点。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightTriangleViz',
  props: { knowledgePoint: { type: String, default: '' } }
}
</script>

<style scoped lang="scss">
.quad-viz-pure { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { padding: 15px; }
.discovery-note { background: rgba(0, 210, 255, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>